import {platformBrowser} from '@angular/platform-browser';
import {AppModule} from './app/app-module';
import {environment} from './environments/environment';

// Startup banner so you can confirm which build/env is running (e.g. in prod devtools).
console.log(
  `[client-media] version=${environment.version} production=${environment.production} api=${environment.api}`,
);

platformBrowser().bootstrapModule(AppModule, {})
  .catch(err => console.error(err));

